import { Context } from '@nuxt/types'
import auth from '~/middleware/auth'

export default async function (context: Context) {
  // reviews
  if (context.route.query?.jwt) {
    return
  }
  // deliverydetail
  if (context.route.query?.hash || context.route.query?.h) {
    return
  }

  return await auth(context)
}
